import {
  MainTableColumnId,
  exportData,
  MainTableSorting,
} from '@prlw/core/monitor/types/main-table';
import {
  mainTableColumns,
  mainTableSortDefaults,
} from '@prlw/core/monitor/init/main-table';
import { Instrument } from '@prlw/core/monitor/instrument.entity';

export function getMainTableDefaultActiveColumns(): MainTableColumnId[] {
  return mainTableColumns.map((column) => column.id);
}

export function getMainTableSortDefault(
  columnId: MainTableColumnId,
): MainTableSorting {
  const defaultSort = mainTableSortDefaults.find(
    (sorting) => sorting.columnId === columnId,
  ) as MainTableSorting;
  return { ...defaultSort };
}

export function getMainTableSortData(
  instrument: Instrument,
  columnId: MainTableColumnId,
): exportData {
  const sortData: { [key: number]: exportData } = {
    [MainTableColumnId.BASIS]: instrument.shipment.code,
    [MainTableColumnId.BRIEF_DESCRIPTION]: instrument.shipment.briefDescription,
    [MainTableColumnId.OFFER]: instrument.quote.sellPrice,
    [MainTableColumnId.DEAL]: instrument.quote.lastDealPrice,
    [MainTableColumnId.DEMAND]: instrument.quote.buyPrice,
    [MainTableColumnId.CHANGES]: instrument.quote.delta,
    [MainTableColumnId.VOLUME]: instrument.currentAmount,
    [MainTableColumnId.PREV_SESSION_VOLUME]: instrument.previousSessionAmount,
    [MainTableColumnId.PREV_DEALS_AMOUNT_DIFF]: instrument.prevDealsAmountDiff,
    [MainTableColumnId.TARIFF]: instrument.tariff,
    [MainTableColumnId.LOCAL_PRICE]: instrument.tariff
      ? instrument.totalPrice
      : 0,
    [MainTableColumnId.SHIPMENT]: instrument.shipmentDays,
    [MainTableColumnId.ON_THE_WAY]: instrument.deliveryDays,
    [MainTableColumnId.TRADE_START]: instrument.expectedTradingStart,
  };
  return sortData[columnId];
}

export function mainTableCompareData(
  a: Instrument,
  b: Instrument,
  sorting: MainTableSorting,
): number {
  const aData = getMainTableSortData(a, sorting.columnId);
  const bData = getMainTableSortData(b, sorting.columnId);
  const isAscending = sorting.direction === 'ASC';

  if (aData === bData || (!aData && aData !== 0) || (!bData && bData !== 0)) {
    return 0;
  }

  if (aData === 0) {
    return 1;
  } else if (bData === 0) {
    return -1;
  }

  if (isAscending) {
    return aData < bData ? -1 : 1;
  }
  return aData < bData ? 1 : -1;
}
